import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Sparkles, AlertTriangle, Check, ArrowRight, Clock } from "lucide-react";
import "./TrialExpired.css";

export default function TrialExpired() {
  const navigate = useNavigate();
  const { logout, trialStatus, activateSubscription } = useAuth();

  const handleSubscribe = async () => {
    await activateSubscription();
    navigate("/dashboard");
  };

  return (
    <div className="trial-expired-page">
      <div className="trial-expired-card">
        <div className="trial-expired-icon">
          <Clock size={36} />
        </div>
        <h1>Your Free Trial Has Ended</h1>
        {trialStatus.storeName && (
          <p className="trial-expired-store">{trialStatus.storeName}</p>
        )}
        <p className="trial-expired-desc">
          Your 7-day free trial of Showroom AiPro has expired. Subscribe now to keep
          your team running with all the AI-powered tools you've been using.
        </p>

        <div className="trial-expired-pricing">
          <div className="trial-expired-price-header">
            <span className="trial-expired-badge">Launch Special</span>
          </div>
          <div className="trial-expired-price-row">
            <span className="trial-expired-strike">$249/mo</span>
            <div className="trial-expired-current">
              <span className="trial-expired-dollar">$</span>
              <span className="trial-expired-amount">99</span>
              <span className="trial-expired-period">/month</span>
            </div>
          </div>
          <ul className="trial-expired-features">
            <li><Check size={15} /> All 10+ AI-powered features</li>
            <li><Check size={15} /> Unlimited team members</li>
            <li><Check size={15} /> No setup fees · Cancel anytime</li>
          </ul>
          <button className="trial-expired-subscribe" onClick={handleSubscribe}>
            Subscribe Now — $99/mo <ArrowRight size={18} />
          </button>
        </div>

        <button className="trial-expired-logout" onClick={() => { logout(); navigate("/"); }}>
          Log Out
        </button>
      </div>
    </div>
  );
}
